import React from 'react';
import { Icon, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { SettingsHeading, DisplayNameInput } from '../../../SidebarMenu/styles';
import { DESIGN_AREA_SETTINGS_TAB } from '../../../SidebarMenu/translationValues';
import { convertContractToReact } from '../../../../utils/TextBlockHelper';
import QuillEditorModal from '../../../../components/Modals/QuillEditorModal';
import { useDisplayNameSettings } from '../hooks/useDisplayNameSettings';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../../../context/complexDocumentContext';
import { useArtboardContext, CONTEXT_KEYS } from '../../../../context/complexArtboardContext';
import CategoryInput from '../CategoryInput.js';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

export const DisplayNameSection = ({ CurrentDesign, isEditMode, readOnly, showLabel = true, customStyles }) => {
  const { t } = useTranslation(NAMESPACES);
  const {
    displayNameDTO,
    displayNameModalVisible,
    openDisplayNameModal,
    closeDisplayNameModal,
    saveDisplayName,
    isLoading,
    editorKey,
    DEFAULT_VALUE,
    documentId
  } = useDisplayNameSettings();

  const customVarSelector = React.useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.GLOBAL_VARIABLES], []);
  const [globalVariables] = useDocumentContext(customVarSelector, 'DisplayNameSection');

  const isOpenDesignSelector = React.useCallback((store) => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign, updateArtboard] = useArtboardContext(isOpenDesignSelector, 'DisplayNameSection');

  const handleOpenDesign = React.useCallback(() => {
    updateArtboard({
      [CONTEXT_KEYS.SHOW_SIGNUP_PROMPT]: true
    });
  }, [updateArtboard]);

  if (CurrentDesign !== 'document') {
    return null;
  }

  return (
    <>
      {showLabel && (
        <SettingsHeading complexDesign style={customStyles}>
          {t(
            DESIGN_AREA_SETTINGS_TAB.DISPLAY_NAME_LABEL.key,
            DESIGN_AREA_SETTINGS_TAB.DISPLAY_NAME_LABEL.value,
          )}{' '}
          <Tooltip
            placement="topLeft"
            title={t(
              DESIGN_AREA_SETTINGS_TAB.DISPLAY_NAME_TOOLTIP.key,
              DESIGN_AREA_SETTINGS_TAB.DISPLAY_NAME_TOOLTIP.value,
            )}
          >
            <Icon type="question-circle" />
          </Tooltip>
        </SettingsHeading>
      )}
      <DisplayNameInput onClick={() => isOpenDesign ? handleOpenDesign() : openDisplayNameModal()}>
        <div className='quill'>
          <div className='ql-container ql-snow ql-preview'>
            {convertContractToReact(displayNameDTO?.contents || DEFAULT_VALUE, undefined, undefined, globalVariables)}
          </div>
        </div>
        <Icon
          type="edit"
          style={{ color: '#000', cursor: 'pointer', fontSize: '18px' }}
          onClick={() => isOpenDesign ? handleOpenDesign() : openDisplayNameModal()}
        />
      </DisplayNameInput>
      <QuillEditorModal 
        key={editorKey}
        visible={displayNameModalVisible}
        value={displayNameDTO?.contents || DEFAULT_VALUE}
        isLoading={isLoading}
        onSave={saveDisplayName}
        onCancel={closeDisplayNameModal}
        inputLabel={t(DESIGN_AREA_SETTINGS_TAB.DISPLAY_NAME_MODAL_LABEL.key, DESIGN_AREA_SETTINGS_TAB.DISPLAY_NAME_MODAL_LABEL.value)}
      />
      <CategoryInput templateId={documentId} isEditMode={isEditMode && !readOnly} />
    </>
  );
};


